export default __webpack_public_path__ + "static/Scholarship-83228ba834d51e2f6a272667d3ed6bff.webp";